<template>
<div>
    
    <section class="page-title" :style="`background-color:#009b9b;${this.$vuetify.breakpoint.lg ? '' : 'margin-top: 0px'};`" >
      <v-img 
             
        :src="require('@/Content/images/banner_senior.png')"
        class="white--text"
        
        max-width="100%"          
      >
    <div class="center">
      <v-layout row wrap>
        <v-flex xs12 sm12 lg12>
            <br>
            <br>
        <h1 class="the-title" style="color:#FFFF;font-size: 45px">Projeto</h1>   
        <h1 class="the-title" style="color:rgb(197 233 228);margin-left: 55px;font-size: 45px">Smile Senior</h1>
        </v-flex>  
                       
        </v-layout>
    </div>
    </v-img>
</section>

<section class="page-content center">
    <v-container fluid grid-list-md>
    <v-layout row wrap>    
    <v-flex xs12 sm12 md12 lg12 style="margin-left: -11px;margin-top: -30px;">
        <v-btn
        style="border-radius: 6px;"
        large                
        dark
        @click="openDialog()"
        color="#009b9b"
        >Contratar agora
        </v-btn>
    </v-flex> 
    <v-flex xs12 sm12 lg10>
    <br>
    <img v-if="this.$vuetify.breakpoint.lg" src="../Content/images/preco_senior.png" style="position: absolute;left: 90%;" width="150px">
    <img v-else src="../Content/images/preco_senior.png" width="150px">
    <p class="title-label">O cuidado com o seu sorriso não tem idade.</p>
    <p>A PrimaVida disponibilizou um plano especial para você que precisa de tratamentos específicos de próteses, incluindo pontes (móvel e parcial), coroa total unitária em resina e "dentadura" em uma nossa rede exclusiva e altamente qualificada a lhe atender e aos seus familiares.</p>    
    <br>    
    </v-flex>    
    <v-flex xs12 sm12 lg7>
    <p class="title-label">Acesso à rede credenciada</p>
    <p>Para acessar a rede credenciada, <a href="http://www.primavida.com.br/redecredenciada" target="_blank">clique aqui.</a></p>
    </v-flex>

    <v-flex xs12 sm12 lg6>
    <p class="title-label">Quem pode aderir ao Plano?</p>
    <ul>Dependentes:</ul>
    <li>Pai / Padrasto</li>
    <li>Mãe / Madrasta</li>
    <li>Filhos / Enteados</li>
    <li>Cônjuge / Companheiro</li>
    <br>
    </v-flex>    

    <v-flex xs12 sm12 lg6>
    <p class="title-label">Principais Vantagens</p>
    <li>Liberação on-line do seu plano de tratamento;</li>
    <li>O Beneficiário pode incluir familiares e agregados;</li>
    <li>Acesso a rede credenciada através do site www.primavida.com.br;</li>
    <li>Possibilidade de credenciamento de Dentistas por indicação do Associado;</li>
    <li>Desconto em medicamentos nas farmácias &nbsp;<img src="../Content/images/raia.jpg" width="60px"> &nbsp; <img src="../Content/images/drogasil.jpg" width="110px"></li>
    <li>Central de Atendimento exclusiva por Whatsapp;</li>
    <li>Aplicativo para Celular / Tablet com rede Credenciada;</li>
    <li>Carteirinha Virtual;</li>
    <li>Boleto Virtual;</li>
    <br>
    </v-flex>

    <v-flex xs12 sm12 lg6>
    <p class="title-label">Carências Reduzidas</p>
    <table class="table-carencia" cellpadding="0" cellspacing="0" border="0">
      <tr>
        <th></th>
        <!-- <th colspan="1">Prazo de Carência</th> -->
      </tr>
      <tr class="mini-header">
        <td>Procedimentos/Eventos Odontológicos</td>
        <!-- <td>Plano Individual/Familiar</td> -->
        <td >Prazo de Carência</td>
      </tr>
      <tr>
        <td>Urgência</td>
        <!-- <td>24 horas</td> -->
        <td class="carencia">24 horas</td>
      </tr>
      <tr>
        <td>Consulta Inicial, Radiologia, Prevenção, Odontopediatria, Periodontia, Dentística, Cirurgia Oral Menor</td>
        <!-- <td>30 dias</td> -->
        <td class="carencia">30 dias</td>
      </tr>
      <tr>
        <td>Endodontia e Prótese</td>
        <!-- <td>60 dias</td> -->
        <td class="carencia">180 dias</td>
      </tr>     
    </table>
    </v-flex>    
    <v-flex xs12 sm12 lg6 style="margin-top: 42px;">
        <v-card
          flat
          max-height="600px"
          max-width="450px"
          class="mx-auto localizacao"
          style="#009b9b;border-radius: 10px;"
          color="rgb(197 233 228)">
          <v-card-text>              
              <v-flex xs12 sm12 lg12>
                <p class="title-label">Formas de pagamento diferenciadas</p>
                <li style="color:#009b9b;font-size: 16px;">Boleto venda à vista:</li>
                <ul>R$1080,00</ul>
                <br>
                <li style="color:#009b9b;font-size: 16px;">Venda cartão de crédito à vista:</li>
                <ul>R$1080,00 (parcelado pelo cartão em até 12x sem juros de R$90,00)</ul>
                <!-- <br>
                <li style="color:#009b9b;font-size: 16px;">Venda à vista por financiamento de cartão:</li>
                <ul>R$1080,00 (em 12x sem juros), valor unitário de R$90,00</ul> -->
              </v-flex>
          </v-card-text>
          </v-card>
    </v-flex>
    
    <v-flex xs12 sm12 lg12>
    <br>
    <p class="title-label" style="color:#212121;">App PrimaVida Beneficiário</p>    
    </v-flex>
    <v-flex xs5 sm5 lg2>
    <img src="../Content/images/app_android.png" width="120px"><br>
    <a href="https://play.google.com/store/apps/details?id=br.com.primavida.associado" target="_blank"><img src="../Content/images/android.png" width="120px"></a>&nbsp;
    </v-flex>
    <v-flex xs5 sm5 lg2>
    <img src="../Content/images/app_apple.png" width="120px"><br>
    <a href="https://apps.apple.com/br/app/primavida-dental-associado/id1464690839" target="_blank"><img src="../Content/images/apple_stote.png" width="120px" ></a>&nbsp;
    </v-flex>
    <v-flex xs5 sm5 lg2>
    <img src="../Content/images/app_whats.png" width="120px"><br>
    <a href="https://api.whatsapp.com/send?phone=5521971640379" target="_blank"><img src="../Content/images/whatsapp.png" width="120px" ></a>&nbsp;
    </v-flex>
    <v-flex xs5 sm5 lg3>
    <img src="../Content/images/celular.png" width="130px"><br>    
    </v-flex>

    <v-flex xs5 sm5 lg12>
        <table cellpadding="0" cellspacing="0" border="1">
      <tr >
        <td style="color: #009b9b;">Plano: </td> 
        <td>&nbsp; SMILE SENIOR </td>
      </tr>
      <tr>
        <td style="color: #009b9b;">Reg ANS nº: </td>
        <td>&nbsp; 483.421/19-6 </td>
      </tr>
      <tr>
        <td style="color: #009b9b;">Tipo de Contratação: </td>
        <td>&nbsp; INDIVIDUAL/FAMILIAR </td>
      </tr>
      <tr>
        <td style="color: #009b9b;">Formação de Preço: </td>
        <td>&nbsp; PRÉ-ESTABELECIDO </td>
      </tr>
      <tr>
        <td style="color: #009b9b;">Área de Abrangênia/Atuação: </td>
        <td>&nbsp; GRUPO DE MUNICÍPIOS RJ </td>
      </tr>
      <tr>
        <td style="color: #009b9b;">Segmetação Assistencial: </td>
        <td>&nbsp; EXCLUSIVAMENTE ODONTOLÓGICA </td>
      </tr>
      <tr>
        <td style="color: #009b9b;">Carência: </td>
        <td>&nbsp; CARÊNCIAS REDUZIDAS </td>
      </tr>
    </table>
    </v-flex>
    
    <v-flex xs12 sm12 lg12>
        <img src="../Content/images/logo.png" width="200">
    </v-flex>

    </v-layout>
    </v-container>
    <br>
    <p class="title-label">Principais Coberturas (Rol da ANS)</p>
    <div class="icone consultas">
        <span class="icon"></span>
        <p><strong>Consultas</strong> - Consultas iniciais para o plano de tratamento;</p>
    </div>
    <div class="icone urgencia">
        <span class="icon"></span>
        <p><strong>Urgência</strong> - Diversos procedimentos de urgência odontológica;</p>
    </div>
    <div class="icone cirurgia">
        <span class="icon"></span>
        <p><strong>Cirurgia</strong> - Cirurgias odontológicas de pequeno porte realizada em consultórios;</p>
    </div>
    <div class="icone dentistica">
        <span class="icon"></span>
        <p><strong>Dentística</strong> - Restaurações e obturações em material estético (Resina) e amálgama;</p>
    </div>
    <div class="icone endodontia">
        <span class="icon"></span>
        <p><strong>Endodontia</strong> - Tratamento de canais;</p>
    </div>
    <div class="icone periodontia">
        <span class="icon"></span>
        <p><strong>Periodontia</strong> - Tratamento de gengivas;</p>
    </div>
    <div class="icone odontopediatria">
        <span class="icon"></span>
        <p><strong>Odontopediatria</strong> - Atendimento especializado para crianças;</p>
    </div>
    <div class="icone radiologia">
        <span class="icon"></span>
        <p><strong>Raio X</strong> - Periapical, interproximal (bite-wing), oclusal, periapical completa (levantamento radiográfico);</p>
    </div>
    <div class="icone protese">
        <span class="icon"></span>
        <p><strong>Próteses</strong> - Coroa provisória, Restauração, Coroa, Núcleo e Bloco metálico para dentes permanentes posteriores, Coroa em Cerômero para dentes permanentes anteriores (Entende-se como dentes permanentes anteriores, os dentes definitivos da frente, que correspondem do canino a canino);</p>
    </div>
    <div class="icone profilaxia">
        <span class="icon"></span>
        <p><strong>Prevenção</strong> - Profilaxia / Aplicação de Flúor;</p>
    </div>
    <div class="icone exodontia">
        <span class="icon"></span>
        <p><strong>Exodontia</strong> - Extração, inclusive de siso incluso;</p>
    </div>
    <div>
        <p>Para acessar a cobertura do Rol da ANS, <a href="http://www.primavida.com.br/emkt/rol_procedimentos.pdf" target="_blank">clique aqui.</a></p>
    </div>
    <v-flex xs12 sm6 md6 lg12 >
        <v-btn
        style="border-radius: 6px;"
        large                
        dark
        @click="openDialog()"
        color="#009b9b"
        >Contratar agora
        </v-btn>
        <img src="../Content/images/logo-ans.png" width="200" style="float:right;">
    </v-flex>
</section>
<v-dialog v-model="dialog" max-width="700px" max-height="400px"> 
      <v-card>
          <v-container grid-list-md>
            <v-layout row wrap justify-center>
              <v-card-title>
              <span class="total">Prezado(a) parceiro(a),</span>              
              </v-card-title>
              <v-container                    
                    fluid
                    pa-1
                    justify-center
                    class="resumo"
                  >
              <p class="resumo" >Valorizamos a privacidade de seus dados. Por isso, investimos em modernidade nos nossos canais de comunicação, garantindo assim a  segurança e a tranquilidade que você precisa.</p>
              <p class="resumo" >Por esse motivo, estamos enviando um termo de privacidade sobre os seus dados cadastrais.</p>
              <p class="resumo" >É necessário que você acesse nossa política de privacidade e aceite os termos para continuarmos recebendo e enviando suas informações.</p>
              <br>
              <p class="resumo" style="font-weight: bold">A <span style="color:#009B99">PrimaVida Dental</span> agradece a sua atenção !</p>
              <p class="resumo" style="font-weight: bold">Vindo de você, tudo é importante!!!</p>
              <br>
              <p class="resumo" style="font-weight: bold;color:#009B99">Termo de Privacidade, <a href="https://ecommerce.primavida.com.br/contratos/Politica_de_Privacidade_PrimaVida_LGPD.pdf" target="_blank">clique aqui.</a></p>
              
              <v-checkbox
                    v-model="contrataccept"
                    color="#009B99"
                >
                <span slot="label">Estou ciente e concordo com o Termo de Privacidade da PrimaVida Dental.</span>
          </v-checkbox>
              </v-container>
            </v-layout>
            <v-card-actions>
              <v-container
                    fill-height
                    fluid
                    pa-1
                    justify-center
                  >
                  <br>
              <v-btn :disabled="!contrataccept" color="#009b9b" depressed style="border-radius: 8px; width: 130px;color: white;" :href="'https://ecommerce.primavida.com.br/contratopf?plano=6060f012976d59059307cd72'">Continuar</v-btn>
              </v-container>
            </v-card-actions>
          </v-container>
      </v-card>
    </v-dialog>
<Snackbar ref=chamaSnackbar />
</div>
</template>
<script>
import Snackbar from '../components/snackbar.vue'
export default {
    components: {Snackbar},
     data(){
        return{   
                contrataccept: false,
                dialog: false,
                matricula: '',
                dictionary: {          
                custom: {               
                carteirinha: {
                  required: () => 'Informe o número da carteirinha'
                } 
                }
                }
        }               
    },

    mounted : function(){
        this.$store.dispatch('EscondeToolbar')
        this.$store.dispatch('EscondeFooter')
        this.$validator.localize('pt', this.dictionary)
        localStorage.clear()
        sessionStorage.clear()

    },
     watch: {
        dialog(val) {
        val || this.close()
      }
     },
    methods: {
        openDialog(){
            this.dialog = true
        }
        
    }

}
</script>

<style>

    .link{
        font-size: 1.3rem;
        color: #194383;
        text-align: center;
    }
    .titulo{
        font-size: 2rem;
        color: #797a7a;
        text-align: center;
    }
    .tabela{
        border-collapse: separate;
        border-spacing: 2;
    }
</style>